<template>
    <header>
        <div class="flex flex-col">
            <div class="flex max-lg:items-center max-lg:justify-between max-lg:px-3.75">
                <BurgerMenu></BurgerMenu>
                <div>
                    <router-link :to="{ name: 'foodHomePage' }">
                        <AppLogo/>

                    </router-link>
                </div>
                <div class="ml-auto flex items-center gap-10 max-lg:hidden">
                   
                    <router-link :to="{ name: 'foodCategories' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.menu') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"  v-if="getLastSeenExhibitionStoresCount > 0">{{ getLastSeenExhibitionStoresCount }}</span>
                    </router-link>

                    <router-link :to="{ name: 'foodRestaurants' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.restaurants') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"  v-if="getLastSeenExhibitionStoresCount > 0">{{ getLastSeenExhibitionStoresCount }}</span>
                    </router-link>
                    <router-link :to="{ name: 'foodLiked' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.liked') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getFoodLikedCount > 0">{{ getFoodLikedCount }}</span>
                    </router-link>
                    <router-link :to="{ name: 'foodCart' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.cart') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getFoodCartItemsCount > 0">{{ getFoodCartItemsCount }}</span>
                    </router-link>
                    <div class="flex ">
                        <LocationButton></LocationButton>
                        <div class="ml-4">

                            <ProfileButton ></ProfileButton>
                        </div>
    
                    </div>
                </div>
                <div class="hidden max-lg:flex">
                    <LocationButton customClass="mr-4 bg-[#f9f9f9] shadow-sm"></LocationButton>
                    <LanguageSwitcher extraclasswrapper="border-black" extraclasslabel="!text-black"></LanguageSwitcher>
                </div>
            </div>
            <div class="hidden max-lg:flex max-lg:mt-5 bg-white">
                <MiddleNav></MiddleNav>
            </div>
            <div class="mt-5">
                <SearchBar section="food" :placeholder="$t('page.searchFoodByName')"></SearchBar>
            </div>
        </div>
    </header>
</template>

<script>
import AppLogo from '@cmp/AppLogo.vue'
import MiddleNav from '@cmp/MiddleNav.vue'
import BurgerMenu from '@cmp/BurgerMenu.vue'
import ProfileButton from '@cmp/ProfileButton.vue'
import SearchBar from '@cmp/SearchBar.vue'
import CategoriesDropdown from '@cmp/publication/CategoriesDropdown.vue'
import LocationButton from '@cmp/LocationButton.vue'
import LanguageSwitcher from '@cmp/LanguageSwitcher.vue'
import FoodCategoriesMenu from "@cmp/food/FoodCategoriesMenu.vue";
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
export default {
    name: 'MallHeader',
    components: {
        AppLogo,
        CategoriesDropdown,
        ProfileButton,
        LocationButton,
        SearchBar,
        BurgerMenu,
        LanguageSwitcher,
        MiddleNav,
        FoodCategoriesMenu
    },
    data(){
        return {
            loading: false,
        }
    },
    methods: {
       
    },
    computed: {
        ...mapState(useAppStore, ['getFoodCartItemsCount', 'getFoodLikedCount', 'getLastSeenExhibitionProductsCount', 'getLastSeenExhibitionStoresCount']),
        exhibitionCategories(){
            return this.$store.exhibitionCategories
        },

    },
    created(){

    }
}
</script>


<style >
</style>
<style scoped>
.router-link-exact-active{
    color: #409DBA;
}
</style>